import { FieldHookConfig, useField } from 'formik'
import { DatePicker as UIDatePicker } from '@carsys/ui'
import { isInvalid } from './utils'
import DateType from '@carsys/ui/src/date-helpers/date-type'
import moment from 'moment'
import { apiFormat } from '@cbgms/base/utils/datetime'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'
import { TextFieldProps } from '@mui/material/TextField'

interface DatePickerProps
  extends Omit<React.ComponentProps<typeof UIDatePicker>, 'name'>,
    Pick<FieldHookConfig<string>, 'name' | 'validate'> {
  required?: boolean
}

export function DatePicker({ name, validate, ...props }: DatePickerProps) {
  const [input, meta, helpers] = useField<string | null>({ name, validate })
  const parentTextFieldProps = props.slotProps?.textField as TextFieldProps | undefined

  useRegisterFormField(name)

  const onChange = (date: DateType) => {
    helpers.setValue(date?.isValid() ? date.format(apiFormat.yearMonthDay) : null)
  }

  return (
    <UIDatePicker
      {...props}
      value={moment(input.value)}
      onChange={onChange}
      slotProps={{
        ...props.slotProps,
        textField: {
          ...parentTextFieldProps,
          id: input.name,
          name: input.name,
          onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
            input.onBlur(e)
            parentTextFieldProps?.onBlur?.(e)
          },
          ...(parentTextFieldProps?.onKeyDown && {
            onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
              parentTextFieldProps.onKeyDown!(e)
            }
          }),
          error: isInvalid(meta),
          // @ts-ignore Fix typescript does not exist error for helperText
          // see: https://github.com/mui/mui-x/issues/8026
          helperText: isInvalid(meta) ? meta.error : parentTextFieldProps?.helperText,
          required: props.required
        }
      }}
    />
  )
}
